/* Barlen-menu: de menubalk met uitschuifpanelen (vanaf 1001 px) en de lade met niveaus (tot 1000 px).
   Computer: een panel opent als de muis 0,1 s (bijna) stilstaat op een item, zodat het meteen uitschuift maar niet flitst
   als de muis alleen langs de balk gaat; staat er al een panel open, dan wisselt het na 0,1 s. Het sluit 0,5 s nadat de
   muis item en panel heeft verlaten, maar alleen als het door aanwijzen openging;
   na een klik op het pijltje (of Enter) blijft het open tot Escape, een klik ernaast of focus erbuiten.
   Telefoon: de knop Menu opent de lade van links; een item met een submenu opent een niveau dat van rechts inschuift.
   Escape gaat een niveau terug en sluit daarna de lade; de focus blijft in de lade en gaat bij sluiten terug naar Menu.
   Zolang een panel of de lade open is, staat de klasse bm-open op html (assets/barlen-kop.js houdt de kop dan zichtbaar). */
(function () {
  'use strict';
  var breed = window.matchMedia('(min-width: 1001px)');
  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var html = document.documentElement;
  var OPEN_MS = 100, WISSEL_MS = 100, DICHT_MS = 500, STIL_PX = 6;
  var paneelOpen = false, ladeOpen = false;
  var luister = function (mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); };
  var zetStand = function () { html.classList.toggle('bm-open', paneelOpen || ladeOpen); };

  /* ---------- Computer: menubalk en panelen ---------- */
  function balk(nav) {
    var items = Array.prototype.slice.call(nav.querySelectorAll('.bm-item'));
    var openLi = null, openDoor = null, tOpen = 0, tDicht = 0, aanwijzer = 'mouse', anker = null;

    var knopVan = function (li) { return li.querySelector('.bm-knop'); };
    /* De beelden in de panelen laden pas als de muis of de focus voor het eerst bij het menu komt. */
    var beeldenAan = function () { Array.prototype.forEach.call(nav.querySelectorAll('.bm-paneel'), function (p) { p.classList.add('bm-ooit'); }); };
    nav.addEventListener('pointerenter', beeldenAan, { once: true });
    nav.addEventListener('focusin', beeldenAan, { once: true });
    function zet(li, door) {
      if (openLi === li) { if (li && door === 'klik') openDoor = 'klik'; return; }
      var wissel = !!openLi && !!li;
      if (wissel) nav.classList.add('bm-wissel');
      if (openLi) { openLi.classList.remove('bm-open'); var k0 = knopVan(openLi); if (k0) k0.setAttribute('aria-expanded', 'false'); }
      openLi = li && li.classList.contains('bm-heeft') ? li : null;
      openDoor = openLi ? (door || 'hover') : null;
      if (openLi) { beeldenAan(); openLi.classList.add('bm-open'); var k1 = knopVan(openLi); if (k1) k1.setAttribute('aria-expanded', 'true'); }
      nav.classList.toggle('bm-dim-aan', !!openLi);
      paneelOpen = !!openLi;
      zetStand();
      if (wissel) requestAnimationFrame(function () { requestAnimationFrame(function () { nav.classList.remove('bm-wissel'); }); });
    }
    function plan(li, e) {
      anker = { x: e.clientX, y: e.clientY };
      clearTimeout(tOpen);
      tOpen = setTimeout(function () { zet(li, 'hover'); }, openLi ? WISSEL_MS : OPEN_MS);
    }
    function sluit(focusTerug) {
      clearTimeout(tOpen); clearTimeout(tDicht);
      var was = openLi;
      zet(null);
      if (focusTerug && was) { var k = knopVan(was); if (k) k.focus(); }
    }
    function laterDicht() { clearTimeout(tDicht); tDicht = setTimeout(function () { zet(null); }, DICHT_MS); }

    items.forEach(function (li) {
      li.addEventListener('pointerenter', function (e) {
        aanwijzer = e.pointerType;
        if (e.pointerType !== 'mouse' || !breed.matches) return;
        clearTimeout(tDicht);
        if (openLi === li) { clearTimeout(tOpen); return; }
        plan(li, e);
      });
      li.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !breed.matches || openLi === li) return;
        // Beweegt de muis nog, dan opnieuw wachten: wie langs de balk beweegt, opent niets.
        if (!anker || Math.abs(e.clientX - anker.x) + Math.abs(e.clientY - anker.y) > STIL_PX) plan(li, e);
      });
      li.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse' || !breed.matches) return;
        clearTimeout(tOpen);
        if (openLi && openDoor === 'hover') laterDicht();
      });
      var knop = knopVan(li);
      if (knop) {
        knop.addEventListener('click', function (e) {
          e.preventDefault();
          clearTimeout(tOpen); clearTimeout(tDicht);
          if (openLi === li && openDoor === 'klik') zet(null); else zet(li, 'klik');
        });
      }
      var link = li.querySelector('a.bm-link');
      if (link && li.classList.contains('bm-heeft')) {
        link.addEventListener('pointerdown', function (e) { aanwijzer = e.pointerType; });
        // Aanraken op een breed scherm (tablet): de eerste tik opent het panel, de tweede gaat naar de pagina.
        link.addEventListener('click', function (e) {
          if (aanwijzer !== 'mouse' && breed.matches && openLi !== li) { e.preventDefault(); zet(li, 'klik'); }
        });
      }
      li.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && openLi === li) { e.stopPropagation(); sluit(true); }
      });
      li.addEventListener('focusout', function (e) {
        if (openLi === li && e.relatedTarget && !li.contains(e.relatedTarget)) zet(null);
      });
    });
    var dim = nav.querySelector('[data-bm-dim]');
    if (dim) {
      dim.addEventListener('click', function () { sluit(false); });
      dim.addEventListener('pointerenter', function () { if (openLi && openDoor === 'hover') laterDicht(); });
    }
    document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && openLi) sluit(true); });
    document.addEventListener('click', function (e) { if (openLi && openDoor === 'klik' && !nav.contains(e.target)) zet(null); });
    luister(breed, function () { if (!breed.matches) sluit(false); });
  }

  /* ---------- Telefoon: de lade ---------- */
  function lade(el) {
    var dim = document.querySelector('[data-bm-lade-dim]');
    // Naar body verplaatsen: een kop met transform zou position: fixed anders aan de kop vastmaken.
    document.body.appendChild(el);
    if (dim) document.body.appendChild(dim);
    var hoofd = el.querySelector('[data-bm-hoofd]');
    var sluitKnop = el.querySelector('[data-bm-dicht]');
    var knoppen = Array.prototype.slice.call(document.querySelectorAll('a[aria-controls="' + el.id + '"]'));
    var actief = null, opener = null, menuKnop = null;
    var wacht = function () { return rustig.matches ? 0 : 60; };

    function naar(id, knop) {
      var niv = document.getElementById(id);
      if (!niv) return;
      opener = knop; actief = niv;
      niv.scrollTop = 0;
      niv.classList.add('bm-actief');
      hoofd.classList.add('bm-achter');
      knop.setAttribute('aria-expanded', 'true');
      setTimeout(function () { var t = niv.querySelector('[data-bm-terug]'); if (t) t.focus({ preventScroll: true }); }, wacht());
    }
    function terug() {
      if (!actief) return;
      actief.classList.remove('bm-actief');
      hoofd.classList.remove('bm-achter');
      actief = null;
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }
    }
    function open(knop) {
      menuKnop = knop || knoppen[0] || null;
      el.classList.add('bm-ooit');
      el.classList.add('bm-lade-open');
      if (dim) dim.classList.add('bm-aan');
      html.classList.add('bm-lade-slot');
      knoppen.forEach(function (k) { k.setAttribute('aria-expanded', 'true'); });
      ladeOpen = true; zetStand();
      setTimeout(function () { var eerste = hoofd.querySelector('a, button'); (eerste || sluitKnop).focus({ preventScroll: true }); }, rustig.matches ? 0 : 80);
    }
    function dicht() {
      if (!el.classList.contains('bm-lade-open')) return;
      el.classList.remove('bm-lade-open');
      if (dim) dim.classList.remove('bm-aan');
      html.classList.remove('bm-lade-slot');
      knoppen.forEach(function (k) { k.setAttribute('aria-expanded', 'false'); });
      ladeOpen = false; zetStand();
      setTimeout(function () {
        if (actief) { actief.classList.remove('bm-actief'); hoofd.classList.remove('bm-achter'); actief = null; }
      }, 300);
      if (menuKnop) menuKnop.focus({ preventScroll: true });
    }

    knoppen.forEach(function (k) {
      /* De foto's van het eerste niveau alvast laden zodra de vinger of muis de menuknop raakt, vóór de klik. */
      k.addEventListener('pointerdown', function () {
        Array.prototype.forEach.call(el.querySelectorAll('.bm-niv-1 img[loading="lazy"]'), function (i) { i.loading = 'eager'; });
      }, { once: true });
      k.addEventListener('click', function (e) {
        e.preventDefault();
        if (el.classList.contains('bm-lade-open')) dicht(); else open(k);
      });
      k.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); if (el.classList.contains('bm-lade-open')) dicht(); else open(k); }
      });
    });
    if (sluitKnop) sluitKnop.addEventListener('click', dicht);
    if (dim) dim.addEventListener('click', dicht);
    Array.prototype.forEach.call(el.querySelectorAll('[data-bm-naar]'), function (b) {
      b.addEventListener('click', function () { naar(b.getAttribute('data-bm-naar'), b); });
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-bm-terug]'), function (b) { b.addEventListener('click', terug); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); if (actief) terug(); else dicht(); return; }
      if (e.key !== 'Tab') return;
      var bereik = actief || hoofd;
      var f = [sluitKnop].concat(Array.prototype.filter.call(bereik.querySelectorAll('a[href], button'), function (x) { return x.offsetParent !== null && getComputedStyle(x).visibility !== 'hidden'; }));
      var eerste = f[0], laatste = f[f.length - 1];
      if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus(); }
      else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
    });
    luister(breed, function () { if (breed.matches) dicht(); });
  }

  function begin() {
    var nav = document.querySelector('[data-bm]');
    if (nav) balk(nav);
    var ld = document.querySelector('[data-bm-lade]');
    if (ld) lade(ld);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin);
  else begin();
})();
